'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HowItWorksV1 = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CallToAction = require('components/CallToAction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorksV1 = exports.HowItWorksV1 = function (_Component) {
  (0, _inherits3.default)(HowItWorksV1, _Component);

  function HowItWorksV1() {
    (0, _classCallCheck3.default)(this, HowItWorksV1);
    return (0, _possibleConstructorReturn3.default)(this, (HowItWorksV1.__proto__ || (0, _getPrototypeOf2.default)(HowItWorksV1)).apply(this, arguments));
  }

  (0, _createClass3.default)(HowItWorksV1, [{
    key: 'renderCta',
    value: function renderCta(ctaCopy, ctaUrl) {
      return _react2.default.createElement(
        _CallToAction.CallToAction,
        {
          action: _CallToAction.ACTIONS.LINK,
          extraClass: 'bt--primary bt--lg text--left how-it-works-v1__bt',
          to: ctaUrl
        },
        ctaCopy
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'How it works';
      var cards = [{
        image: require('./static/img/card1-v1.jpg'),
        caption: 'Search',
        id: 1
      }, {
        image: require('./static/img/card2-v1.jpg'),
        caption: 'Book',
        id: 2
      }, {
        image: require('./static/img/card3-v1.jpg'),
        caption: 'Go',
        id: 3
      }];
      var phone = require('./static/img/phone.png');
      var subtitle = 'It’s that easy.';
      var copy = 'Whether you’re looking for your favorite class or looking to discover your new thing, the ClassPass app makes it effortless.';
      var ctaCopy = 'Learn more';
      var ctaUrl = '/features';

      return _react2.default.createElement(
        'div',
        { className: 'how-it-works-v1' },
        _react2.default.createElement(
          'h2',
          { className: 'how-it-works-v1__title' },
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'how-it-works-v1__content' },
          _react2.default.createElement(
            'ol',
            null,
            cards.map(function (card) {
              return _react2.default.createElement(
                'li',
                { className: 'how-it-works-v1__content__step', key: card.id },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'em',
                    { className: 'how-it-works-v1__content__step__number' },
                    card.id
                  ),
                  _react2.default.createElement(
                    'h3',
                    { className: 'how-it-works-v1__content__step__caption' },
                    card.caption
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'how-it-works-v1__content__step__phone' },
                  _react2.default.createElement('img', { className: 'how-it-works-v1__content__step__phone__screen', src: card.image, alt: card.caption }),
                  _react2.default.createElement('img', { className: 'how-it-works-v1__content__step__phone__frame', src: phone, alt: card.caption })
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'how-it-works-v1__content__start' },
            _react2.default.createElement(
              'h3',
              null,
              subtitle
            ),
            _react2.default.createElement(
              'p',
              null,
              copy
            ),
            _react2.default.createElement(
              'div',
              null,
              this.renderCta(ctaCopy, ctaUrl)
            )
          )
        )
      );
    }
  }]);
  return HowItWorksV1;
}(_react.Component);